/**
 * @global
 * @namespace
 */
class MoveIdea
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#move-idea-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});
	}

	open(endpoint, ideaName)
	{
		this._popupHelper.open(endpoint, ideaName);
	}

	_resetFields(endpoint, ideaName)
	{
		$(`${this._popupHelper.containerSelector} .idea-name`).html(ideaName);
		$(`${this._popupHelper.containerSelector} [name="select-challenge"]`).prop("checked", false);
	}

	_submitRequest(endpoint, ideaName)
	{
		const $checkedChallenge = $(`${this._popupHelper.containerSelector} input:checked[name="select-challenge"]`);
		const challengeId = $checkedChallenge.val();
		
		const popupHelper = this._popupHelper;
		const data = {
			toChallengeId: challengeId
		};
		popupHelper.showLoading();

		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response)
			{
				popupHelper.close();
				window.location.href = response;
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}